import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, interval } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SessionTimerService {
  private readonly durationMs = 60 * 60 * 1000;
  private expiryTimestamp = 0;
  private active = false;
  private readonly remainingSubject = new BehaviorSubject<number>(this.durationMs);

  readonly remainingMs$ = this.remainingSubject.asObservable();

  constructor(private auth: AuthService, private router: Router) {
    interval(1000).subscribe(() => this.tick());
  }

  start(): void {
    this.active = true;
    this.extend();
  }

  stop(): void {
    this.active = false;
    this.expiryTimestamp = 0;
    this.remainingSubject.next(this.durationMs);
  }

  recordActivity(): void {
    if (!this.active) return;
    this.extend();
  }

  private extend(): void {
    this.expiryTimestamp = Date.now() + this.durationMs;
    this.updateRemaining();
  }

  private tick(): void {
    if (!this.active) return;
    this.updateRemaining();
    if (this.remainingSubject.value <= 0) {
      this.active = false;
      this.auth.logout();
      this.router.navigateByUrl('/login');
    }
  }

  private updateRemaining(): void {
    const remaining = Math.max(0, this.expiryTimestamp - Date.now());
    this.remainingSubject.next(remaining);
  }
}
